<div *ngIf="isReady && kpiDates" class="dash-kpi">
  <div class="dash-kpi-values">
    <span class="dash-kpi-value">{{ amt | number }}</span>
    <span class="dash-kpi-pct">{{ pct === null ? '—' : (pct | number: '1.1-1') + '%' }}</span>
  </div>
  <div class="dash-kpi-label">Orders shipped complete in the first shipment</div>
  <div class="dash-kpi-caption">of {{ totalAmt | number }} orders shipped for the first time</div>
  <div class="dash-kpi-caption">{{ rangeText }}</div>
</div>
<div *ngIf="isReady && !kpiDates" class="dash-kpi">
  <div class="dash-kpi-caption">Select a start date and an end date.</div>
</div>
<div *ngIf="!isReady" class="dash-kpi">
  <i class="pi pi-spin pi-spinner text-2xl"></i>
</div>
